import { ApiAddress } from "../apis"
import request from "../request"

export interface ContactInfo {
  id: number
  email: string
  firstName: string
  lastName: string
  phone: string
  company?: string
  companySize?: string
  message?: string
}

export const getContactInfoList = (): Promise<ContactInfo[]> => {
  return request.get(ApiAddress.CONTACT_INFO_LIST)
}

export const createContactInfo = (body: any): Promise<ContactInfo> => {
  return request.post(ApiAddress.CONTACT_INFO_LIST, body)
}

export const deleteContactInfo = (id: number): Promise<ContactInfo> => {
  return request.delete(ApiAddress.CONTACT_INFO_ITEM, {params: {id}})
}

